import { AnimatePresence } from 'framer-motion';
import { InfoContainer } from './InfoContainer';

export function SliceInfo(props) {

    const { show, currentQuestion } = props;


    return (
        <AnimatePresence>
            {show && (
                <InfoContainer currentQuestion={currentQuestion} />
            )}
        </AnimatePresence>
    )
}
